const terminalStates = new Set(['aprobada', 'cancelada', 'finalizada', 'revisada']);

// Cada ejecución consulta el destino real de la foto; el estado de otra pantalla
// no autoriza ni impide su envío. El servidor conserva la decisión final.
export function createScopedVisitaMediaUploader({ userId, isCurrent, getStructure, hasPendingStructure, getStatus, upload, notifyConflict = () => {}, isFormBlocked = () => false, hasPendingStart = async () => false }) {
    const states = new Map(), notified = new Set();
    const conflict = (visitId) => {
        const message = `La visita N° ${visitId} no admite cambios de fotos en su estado actual. La foto queda conservada para revisión.`;
        if (!notified.has(visitId)) { notified.add(visitId); notifyConflict(message); }
        return { success: false, conflict: true, message };
    };
    const prepare = async (item) => {
        if (!isCurrent()) return { success: false, unauthorized: true };
        const visitId = Number(item.visitaId);
        if (!Number.isSafeInteger(visitId) || visitId <= 0 || Number(item.queueEntry?.userId) !== Number(userId)) {
            throw new Error('La foto pendiente no corresponde a esta cuenta o visita. Se conserva para revisión.');
        }
        // Documentación no depende de índices de formulario ni del estado editable de fotos.
        // El servidor conserva el permiso específico de actualizar documentos.
        if (item.attachmentKind === 'document') {
            return await hasPendingStart(visitId) ? {success:false} : null;
        }
        if(isFormBlocked(visitId))return {success:false,conflict:true,message:'Los formularios cambiaron. La foto se conserva hasta revisar la actualización.'};
        const structure = await getStructure(visitId, userId);
        if (!isCurrent()) return { success: false, unauthorized: true };
        if (hasPendingStructure(structure, visitId)) return { success: false };
        if (!states.has(visitId)) states.set(visitId, getStatus(visitId));
        const status = await states.get(visitId);
        if (!isCurrent()) return { success: false, unauthorized: true };
        if (typeof status?.estado !== 'string' || !status.estado.trim()) {
            throw new Error('No se pudo confirmar el estado de la visita. La foto sigue pendiente.');
        }
        if (!item.attachmentCommand && terminalStates.has(String(status?.estado || '').toLowerCase())) return conflict(visitId);
        return null;
    };
    const send = async item => {
        const blocked = await prepare(item);
        if (blocked) return blocked;
        const visitId = Number(item.visitaId);
        try {
            const response = await upload(item);
            if (!isCurrent()) return { success: false, unauthorized: true };
            // El journal verifica HTTP y recibo completo; no reducirlo a success.
            if (item.attachmentCommand) return response;
            const data = response?.data || response || {};
            if (data.ignored === true || data.conflict === true) return { success: false, conflict: true };
            const success = data.success === true || Boolean(data.filename || data.url || data.imagen);
            return { success, uploaded: success };
        } catch (error) {
            const message = String(error?.response?.data?.error || error?.response?.data?.message || '').toLowerCase();
            if (error?.response?.status === 422 && /estado: (aprobada|cancelada|revisada)|finalizada|no editable/.test(message)) return conflict(visitId);
            throw error;
        }
    };
    send.prepare = prepare;
    return send;
}
